import axios from 'axios'
import qs from 'qs';

export default {
    authLogin(payload) {
        return axios.post('/auth/login', qs.stringify(payload))
    }
}
